import angular from 'angular';

import LinkToLicenseRenewalFormComponent from './link-to-license-renewal-form-component';
import { LinkToLicenseRenewalFormController } from './link-to-license-renewal-form-controller';

export default angular
    .module('link-to-license-renewal-form', [])
    .controller('LinkToLicenseRenewalFormController', LinkToLicenseRenewalFormController)
    .component('licenseRenewalLink', LinkToLicenseRenewalFormComponent);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/components/link-to-license-renewal-form/link-to-license-renewal-form-module.js